module.exports = __webpack_public_path__ + "static/img/cytonn-photography-vWchRczcQwM-unsplash_thumb.8730461.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/cytonn-photography-vWchRczcQwM-unsplash_thumb.png
// module id = U1rT
// module chunks = 4